<template>
    <div class="page-wrapper flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding flex-sub flex flex-direction">
            <div class="page-list round flex flex-direction" v-loading="loading">
                <div class="dept-item flex flex-direction"
                     v-for="(item,index) in lists" :key="index">
                    <div class="dept-header flex align-center" @click="expandItem(index)">
                        <i class="icon" :class="item.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
                        <div class="name">{{ item.name }}</div>
                        <div class="count">({{ item.member.length }}人)</div>
                    </div>
                    <div class="member-list flex flex-direction" v-if="item.expand">
                        <div class="member-item flex align-center" v-for="(member,pos) in item.member" :key="pos">
                            <div class="flex align-center flex-sub">
                                <div class="avatar">{{ member.mnickname | mnickname }}</div>
                                <div class="info">{{ member.mnickname }}</div>
                            </div>
                            <div class="info flex-sub">{{ member.msex | sex }}</div>
                            <div class="info flex-sub">{{ member.mphone }}</div>
                            <div class="operate">
                                <el-button type="primary" class="btn smid" @click="setMemberPower(pos,index,member)">
                                    权限管理
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <set-member-power-dialog :dialog-visible="setMemberPowerDialog" :role="cur_role" :mid="cur_mid" :index="cur_index" :pos="cur_pos" @watchState="watchState"></set-member-power-dialog>
    </div>
</template>

<script>

import {getOrgMemberPower} from "@/api";
import SetMemberPowerDialog from "@/views/web/components/SetMemberPowerDialog";

export default {
    name: "role",
    components: {SetMemberPowerDialog},
    data() {
        return {
            lists: [],
            loading: false,
            setMemberPowerDialog: false,
            cur_mid: '',
            cur_role: '',
            cur_index: '',
            cur_pos: '',
        }
    },
    created() {
        this.$emit('setIndex', [8, 0])
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getOrgMemberPower(this.user.power)
            _data.data.map((item, index) => {
                item.expand = index === 0
            })
            this.loading = false
            this.lists = _data.data
        },
        setMemberPower(pos, index, member) {
            this.cur_index = index
            this.cur_pos = pos
            this.cur_role = member.role
            this.cur_mid = member.mid
            this.setMemberPowerDialog = true
        },
        watchState(data) {
            this.setMemberPowerDialog = false
            if (data) {
                let _item = this.lists[data.index].member[data.pos]
                _item.role = data.role
                this.lists[data.index].member.splice(data.pos, 1, _item)
            }
        },
        expandItem(index) {
            this.lists[index].expand = !this.lists[index].expand
        },
    },
    filters: {
        mnickname(name) {
            if (!name) return ''
            return name.substr(0, 1)
        },
        sex(sex) {
            if (!sex) return '--'
            return Number(sex) === 1 ? '男' : '女'
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .dept-item {
        margin-bottom: 10px;

        .dept-header {
            height: 60px;
            background-color: #f4f4f4;
            border-radius: 10px;
            padding: 0 23px;
            cursor: pointer;

            .icon {
                font-size: 18px;
                color: #333333;
            }

            .name {
                font-size: 18px;
                font-weight: 600;
                color: #333333;
                margin: 0 10px;
            }

            .count {
                font-size: 18px;
                color: #333333;
            }
        }

        .member-list {
            .member-item {
                height: 80px;
                padding: 0 32px;

                &:not(:last-child) {
                    border-bottom: 1px solid #e7e7e7;
                }

                .avatar {
                    width: 41px;
                    height: 41px;
                    border-radius: 41px;
                    line-height: 41px;
                    text-align: center;
                    background-color: #1e3c62;
                    font-size: 18px;
                    color: #ffffff;
                    margin-left: 15px;
                    flex-shrink: 0;
                }

                .info {
                    font-size: 16px;
                    color: #333333;
                    padding: 0 16px;
                }
            }
        }
    }
}
</style>
